<template>
  <vc-share-a
    :href="shareIconUrl"
    :target="disabled ? '_self' : '_blank'"
    rel="nofollow"
  >
    <img
      :src="imageSrc[imageType]"
      alt="logo"
      :width="iconSize"
      :height="iconSize"
      :class="[$style.shareIcon, imageClass]"
    />
  </vc-share-a>
</template>

<script>
export default {
  name: "vc-share-hatena-share-icon",
  props: {
    srcUrl: {
      type: String,
      default: ""
    },
    iconSize: {
      type: String,
      default: "35px"
    },
    imageClass: {
      type: Array,
      default: () => {
        return [];
      }
    },
    imageType: {
      type: String,
      default: "normal"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      imageSrc: {
        normal: require("./assets/ph_sns_hb.png"),
        footer: require("./assets/ph_sns_hb_b.png")
      }
    };
  },
  computed: {
    shareIconUrl: function() {
      return this.getShareIconUrl();
    }
  },
  methods: {
    getShareIconUrl: function() {
      if (this.disabled) {
        return "javascript:void(0)";
      }
      return (
        "https://b.hatena.ne.jp/add?mode=confirm&url=" + encodeURI(this.srcUrl)
      );
    }
  }
};
</script>

<style module>
.shareIcon:hover {
  opacity: 0.5;
}
</style>
